export var StatusValue;
(function (StatusValue) {
    StatusValue["PENDING"] = "PENDING";
    StatusValue["POSTED"] = "POSTED";
    StatusValue["CANCELED"] = "CANCELED";
    StatusValue["REJECTED"] = "REJECTED";
    StatusValue["SCHEDULED"] = "SCHEDULED";
    StatusValue["PROCESSING"] = "PROCESSING";
})(StatusValue || (StatusValue = {}));
export var PENDING_GROUP = {
    PENDING: StatusValue.PENDING,
    PROCESSING: StatusValue.PROCESSING,
    SCHEDULED: StatusValue.SCHEDULED
};
export var POSTED_GROUP = {
    CANCELED: StatusValue.CANCELED,
    POSTED: StatusValue.POSTED,
    REJECTED: StatusValue.REJECTED
};
//# sourceMappingURL=status.js.map